<template>
    <div> hello projects page </div>
</template>

<script>
	import {routeExporter} from '../../helpers'

    export default routeExporter({
        data() {
            return {

            }
        },

    })
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// Projects.vue?74ae4ee4